import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export function useRetryMail() {
  const queryClient = useQueryClient();

  const retryMail = async (mailId: number) => {
    await axios.put(`${Config.apiBaseUrl}/mails/${mailId}`);
  };

  const mutation = useMutation({
    mutationFn: retryMail,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["mails"] });
    }
  });

  return mutation;
}
